import "./newsComponent.css"
import {Post} from "react-vk";

export default function ForSpeshialists () {

    return (
        <div className="news-container">
            <Post
                elementId={"vk_post_-217192911_9"}
                ownerId={-217192911}
                postId={9}
                hash={"oIbI4BrxxXCI6W9lO1iZC3UukFVJ"} />

            <Post
                elementId={"vk_post_-217192911_7"}
                ownerId={-217192911}
                postId={7}
                hash={"z1NdsiSs5Ri4arqT67cFwsz--FGr"} />
        </div>
    )
}